import { useState } from 'react';
import type { Country } from 'react-phone-number-input';

interface GeoData {
  country: Country;
  isLoading: boolean;
  error: string | null;
}

/**
 * Returns the default country for phone number input.
 * 
 * Privacy-compliant implementation: Does not send user IP to third-party services.
 * Since this is an Indian real estate website, we default to 'IN'.
 * 
 * @param fallbackCountry - The country code to use (defaults to 'IN' for India)
 * @returns GeoData with the country code
 */
export function useGeoDetection(fallbackCountry: Country = 'IN'): GeoData {
  const [country] = useState<Country>(fallbackCountry);
  
  // Simply return the fallback country without making external API calls
  // This is privacy-compliant and appropriate for an Indian real estate site
  return { 
    country, 
    isLoading: false, 
    error: null 
  };
}